import { Outlet } from 'react-router-dom';
import { Sidebar } from './Sidebar';
import { Header } from './Header';
import { ImpersonationBanner } from './ImpersonationBanner';
import { useDashboardTheme } from '@/hooks/useDashboardTheme';
import { EnvironmentBadge } from '@/components/EnvironmentBadge';

export function MainLayout() {
  // Apply theme class based on user role (superadmin vs tenantadmin)
  useDashboardTheme();

  return (
    <div className="min-h-screen bg-background flex">
      <EnvironmentBadge />
      <Sidebar />
      <div className="flex-1 flex flex-col md:ltr:ml-[270px] md:rtl:mr-[270px] transition-all duration-300">
        <Header />
        <ImpersonationBanner />
        <main className="flex-1 p-6 overflow-x-hidden">
          <div className="max-w-7xl mx-auto space-y-6 animate-in fade-in slide-in-from-bottom-4 duration-500">
            <Outlet />
          </div>
        </main>
      </div>
    </div>
  );
}
